import styled from '@emotion/styled';

const DisabledTitle = styled('span')({
  paddingLeft: '1rem',
});

export default DisabledTitle;
